import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { IStageStatusPair } from 'wisestep-api';
import { WsButton, LoaderIcon } from 'wisestep-base';

import StageStatusFilterPopUp from '../../../features/submissions/submissionListing/components/stageStatusFilterPopup';
import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';

const StageStatusFilter = ({
  name,
  title = 'Stage Status',
  stageStatus,
  showAccordionIcon,
}: WsFilterProps) => {
  const { setValue } = useFormContext();
  const [openStageStatusFilter, setOpenStageStatusFilter] = useState<boolean>(false);

  const onSelectStageStatus = (data: IStageStatusPair[]) => {
    setValue(name, data);
    setOpenStageStatusFilter(false);
  };
  return (
    <>
      <WsAccordion title={title} startIcon={showAccordionIcon ? <LoaderIcon /> : null}>
        <WsButton variant="text" onClick={() => setOpenStageStatusFilter(true)}>
          Stage Status
        </WsButton>
      </WsAccordion>
      <StageStatusFilterPopUp
        open={openStageStatusFilter}
        onClose={() => setOpenStageStatusFilter(false)}
        onSelect={onSelectStageStatus}
        stageStatus={stageStatus}
      />
    </>
  );
};
export default StageStatusFilter;
